import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";

const ProductSubmitForm = ({
  productInfo,
  additionalInfo,
  selectedImages,
  selectedMultiImages,
}) => {
  return (
    <>
      <Typography align={"center"} variant='h2' my={2}>
        Product Details
      </Typography>
      <Stack
        direction='column'
        divider={<Divider orientation='vertical' flexItem />}
        spacing={3}
      >
        <Stack direction='column' spacing={2} border='1px solid #edf1f7' p={2}>
          <Typography variant='h3'> PRODUCT INFO</Typography>
          <Divider></Divider>
          <Typography>
            Product Category: {productInfo.productCategory}
          </Typography>
          <Typography> Product Name: {productInfo.productName}</Typography>
          <Typography>
            Product Brand/Vendor: {productInfo.productBrand}
          </Typography>
          <Typography> Product Price: {productInfo.productAmount}</Typography>
          <Typography>
            Product Discount Price: {productInfo.productDiscountPrice}
          </Typography>

          <Typography>
            Product Discount Percentage: {productInfo.productDiscountPercentage}
          </Typography>
          <Typography> Product Tag: {productInfo.productTag}</Typography>
          <Typography>Product Image:</Typography>
          <img
            src={selectedImages}
            alt=''
            style={{
              maxHeight: 80,
              maxWidth: 80,
            }}
          />
        </Stack>
        <Stack direction='column' spacing={2} border='1px solid #edf1f7' p={2}>
          <Typography variant='h3'> PRODUCT ADDITIONAL INFO</Typography>
          <Divider></Divider>
          <Typography>
            Product Description : {additionalInfo.productDescription}
          </Typography>
          <Typography>
            Product Benefits : {additionalInfo.productBenefits}
          </Typography>
          <Typography>
            Storage And Usage : {additionalInfo.storageAndUsage}
          </Typography>
          <Typography>
            Other Product Info : {additionalInfo.otherProductInfo}
          </Typography>
          <Typography>
            Is Weight Variable :{" "}
            {additionalInfo.isWeightVariable ? "Yes" : "No"}
          </Typography>
        </Stack>
        <Stack direction='column' spacing={2} border='1px solid #edf1f7' p={2}>
          <Typography variant='h3'> PRODUCT IMAGES</Typography>
          <Divider></Divider>
          <Typography variant='p' my={2}>
            Product Multi Image:
          </Typography>
          <Box>
            {selectedMultiImages?.map((multiImages, idx) => {
              return (
                <img
                  style={{ display: "inline", marginRight: "10px" }}
                  src={multiImages}
                  alt=''
                  key={idx}
                  height={80}
                  width={100}
                />
              );
            })}
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default ProductSubmitForm;
